import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { getData, postData } from '../lib/utils';
import { Context } from "../components/contexts/AppContext";

const ChooseYourPlan = () => {
  const navigate = useNavigate();
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData("admin/admin-details");
        setAppState((prevState) => ({
          ...prevState,
          adminDetails: response.admin,
        }));
      } catch (error) {
        console.error("Error fetching admin details:", error);
      }
    };

    const token = localStorage.getItem('authToken');
    if (token === null) {
      navigate("/login");
    } else {
      fetchData();
    }
  }, []);

  // ✅ Handle plan click
  const handlePlanClick = async (planName, featureOption = null) => {
    const stripePromise = loadStripe('pk_test_51RQ4tn2fnTkCyqFhDwtMg7r3I1JFBU9nw6S8RBbNodXQOG9AIT8yExCByTEE4FLADwqEfCNuRc5v37qo5z1tMqMt00jXcKzByj');
    const stripe = await stripePromise;

    let requestBody = {
      name: planName,
      currency: 'usd',
      email: appState.adminDetails.email,
      userId: appState.adminDetails.id,
    };

    if (featureOption) {
      // 🧾 On Demand Plan
      const price = parseInt(featureOption[2].replace("$", "")) * 100;
 
      requestBody = {
        ...requestBody,
        credits: featureOption[1].replace("GB", "")*1024, // e.g. 25GB
        description: `${featureOption[0]} - ${featureOption[1]}`, // e.g. "5 Credits - 25GB"
        price,
        mode: "payment",
      };
    } else {
      // 🔁 Subscription Plan (Pro / Unlimited)
      let price, interval = "month";
      

     if (planName.toLowerCase() === "pro") {
 
  price = 7900; // $79/mo
  requestBody.credits = 1024*1024; // ✅ 1TB = 1,048,576 MB (1 TB)
} else if (planName.toLowerCase() === "unlimited") {
  
  price = 16500; // $165/mo
  requestBody.credits = 5 * 1024*1024; // ✅ 5TB = 5,242,880 MB (5 TB)
}
 else {
        alert("Invalid subscription plan.");
        return;
      }

      requestBody = {
        ...requestBody,
        description: `${planName} Monthly Plan`,
        price,
        interval,
        mode: "subscription",
      };
    }

    try {
      const response = await postData("admin/makepayment", requestBody);
      if (response?.url) {
        window.location.href = response.url;
      } else {
        alert("Stripe session creation failed.");
      }
    } catch (err) {
      console.error("Payment initiation failed", err);
      alert("Something went wrong while initiating payment.");
    }
  };

  // ✅ Available plans
  const plans = [
    {
      name: 'On Demand',
      title: '(No Monthly Fees)',
      price: '',
      features: [
        ['5 Credits', '25GB', '$35'],
        ['10 Credits', '50GB', '$65'],
        ['20 Credits', '100GB', '$120'],
        ['100 Credits', '500GB', '$500']
      ],
    },
    {
      name: 'Pro',
      price: '$79/mo',
      features: [
        'Deliver Video + Photo',
        '1TB of Upload per year',
        '2 Years of Gallery Access + Downloads',
        'White-labeling Add-on included'
      ],
    },
    {
      name: 'Unlimited',
      price: '$165/mo',
      features: [
        'Deliver Video + Photo',
        '5TB of Upload per year',
        '2 Years of Gallery Access + Downloads',
        'White-labeling Add-on included'
      ],
    },
  ];

  return (
    <div className="bg-gray-900 text-white min-h-screen py-12 px-4">
      <div className="flex justify-between px-2 items-center text-white relative" style={{ zIndex: "9999999" }}>
        <div className="text-3xl font-bold text-center mb-8">
          {`Hi ${appState.adminDetails.name}, Choose Your Plan Here to Continue...`}
        </div>
      </div>

      <h2 className="text-3xl font-bold text-center mb-8">Our Pricing Plans</h2>

      <div className="grid gap-8 md:grid-cols-3 max-w-6xl mx-auto">
        {plans.map((plan) => (
          <div
            key={plan.name}
            className="border border-gray-700 rounded-xl p-6 hover:scale-105 transition-transform duration-300 hover:shadow-lg hover:bg-gray-800"
          >
            <h3 className="text-2xl font-semibold text-yellow-400">{plan.name}</h3>
            {plan.title && <h3 className="text-xl font-medium text-yellow-300">{plan.title}</h3>}
            {plan.price && <p className="text-3xl font-bold mb-4">{plan.price}</p>}

            <ul className="mb-6 space-y-2 text-lg font-bold">
              {plan.features.map((feature, idx) =>
                Array.isArray(feature) ? (
                  <li key={idx}>
                    <button
                      onClick={() => handlePlanClick(plan.name, feature)}
                      className="w-full flex justify-between items-center bg-gray-800 hover:bg-gray-700 text-gray-200 px-4 py-2 rounded"
                    >
                      <span>{feature[0]}&nbsp;{feature[1]}</span>
                      <span>{feature[2]}</span>
                    </button>
                  </li>
                ) : (
                  <li key={idx} className="text-gray-300">• {feature}</li>
                )
              )}
            </ul>

            {plan.name !== "On Demand" && (
              <button
                onClick={() => handlePlanClick(plan.name)}
                className="mt-auto bg-yellow-800 hover:bg-yellow-700 text-white px-4 py-2 rounded w-full"
              >
                Choose {plan.name}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseYourPlan;
